import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ErrorsService } from '../../../api';

@Injectable({
  providedIn: 'root',
})
export class BackendErrorLoggerService {
  constructor(private errorService: ErrorsService) {}

  public log$(name: string, message: string, stack: string): Observable<unknown> {
    return this.errorService.logError({ name, message, stack });
  }
}
